import { get } from 'lodash';
import { createSelector } from 'reselect';
import { getFormValues } from 'redux-form';

import { VENDORLINK_MAPPINGS_FORM_NAME } from 'Common/FormEnum';
import { SISFieldEnum } from 'Common/Constants/SISIntegration';

// Configuration
export const getDataLoading = state =>
  get(state, 'VendorLinkIntegrationState.getData.loading');
export const getDataErrors = state =>
  get(state, 'VendorLinkIntegrationState.getData.errors');

export const getConfigurationLoading = state =>
  get(state, 'VendorLinkIntegrationState.getConfiguration.loading');
export const getConfigurationErrors = state =>
  get(state, 'VendorLinkIntegrationState.getConfiguration.errors');
export const getConfigurationResult = state =>
  get(state, 'VendorLinkIntegrationState.getConfiguration.data');

export const postGetLeaInfoRefIdsLoading = state =>
  get(state, 'VendorLinkIntegrationState.postGetLeaInfoRefIds.loading');
export const postGetLeaInfoRefIdsErrors = state =>
  get(state, 'VendorLinkIntegrationState.postGetLeaInfoRefIds.errors');
export const postGetLeaInfoRefIdsResult = state =>
  get(state, 'VendorLinkIntegrationState.postGetLeaInfoRefIds.data');

export const postTestConnectionLoading = state =>
  get(state, 'VendorLinkIntegrationState.postTestConnection.loading');
export const postTestConnectionErrors = state =>
  get(state, 'VendorLinkIntegrationState.postTestConnection.errors');
export const postTestConnectionResult = state =>
  get(state, 'VendorLinkIntegrationState.postTestConnection.data');

export const setConfigurationLoading = state =>
  get(state, 'VendorLinkIntegrationState.setConfiguration.loading');
export const setConfigurationErrors = state =>
  get(state, 'VendorLinkIntegrationState.setConfiguration.errors');
export const setConfigurationResult = state =>
  get(state, 'VendorLinkIntegrationState.setConfiguration.data');

// Mappings
export const getMappingsLoading = state =>
  get(state, 'VendorLinkIntegrationState.getMappings.loading');
export const getMappingsErrors = state =>
  get(state, 'VendorLinkIntegrationState.getMappings.errors');
export const getMappingsResult = state =>
  get(state, 'VendorLinkIntegrationState.getMappings.data');

export const getSitesLoading = state =>
  get(state, 'VendorLinkIntegrationState.getSites.loading');
export const getSitesErrors = state =>
  get(state, 'VendorLinkIntegrationState.getSites.errors');
export const getSitesResult = state =>
  get(state, 'VendorLinkIntegrationState.getSites.data');

export const getGradesLoading = state =>
  get(state, 'VendorLinkIntegrationState.getGrades.loading');
export const getGradesErrors = state =>
  get(state, 'VendorLinkIntegrationState.getGrades.errors');
export const getGradesResult = state =>
  get(state, 'VendorLinkIntegrationState.getGrades.data');

export const getMPWSites = state => get(state, 'CommonState.sites.info.Data');

export const getSitesOptions = createSelector(
  getSitesResult,
  getFormValues(VENDORLINK_MAPPINGS_FORM_NAME),
  (sites, formValues) => {
    if (!sites) {
      return [];
    }

    const options = sites.map(schoolInfo => ({
      Id: schoolInfo[get(formValues, SISFieldEnum.Site)],
      Description: schoolInfo.SchoolName,
    }));

    return options;
  }
);

export const setMappingsLoading = state =>
  get(state, 'VendorLinkIntegrationState.setMappings.loading');
export const setMappingsErrors = state =>
  get(state, 'VendorLinkIntegrationState.setMappings.errors');
export const setMappingsResult = state =>
  get(state, 'VendorLinkIntegrationState.setMappings.data');

// Preview
export const getPreviewStudentId = state =>
  get(state, 'VendorLinkIntegrationState.preview.studentId');
export const getPreviewLoading = state =>
  get(state, 'VendorLinkIntegrationState.preview.loading');
export const getPreviewBeenRun = state =>
  get(state, 'VendorLinkIntegrationState.preview.beenRun');
export const getPreviewSuccess = state =>
  get(state, 'VendorLinkIntegrationState.preview.success');
export const getPreviewErrors = state =>
  get(state, 'VendorLinkIntegrationState.preview.errors');
export const getPreviewData = state =>
  get(state, 'VendorLinkIntegrationState.preview.data');

// Single Student Import
export const getSingleImportLoading = state =>
  get(state, 'VendorLinkIntegrationState.importStudent.loading');
export const getSingleImportSuccess = state =>
  get(state, 'VendorLinkIntegrationState.importStudent.success');
export const getSingleImportErrors = state =>
  get(state, 'VendorLinkIntegrationState.importStudent.errors');
export const getSingleImportData = state =>
  get(state, 'VendorLinkIntegrationState.importStudent.data');

// Bulk Import
export const getBulkImportIsComplete = state =>
  get(state, 'VendorLinkIntegrationState.bulkImport.isComplete');
export const getBulkImportLoading = state =>
  get(state, 'VendorLinkIntegrationState.bulkImport.loading');
export const getBulkImportErrors = state =>
  get(state, 'VendorLinkIntegrationState.bulkImport.errors');
export const getNotifications = state =>
  get(state, 'GlobalUIState.notifications');



// WEBPACK FOOTER //
// ./src/pages/vendorlinkintegration/state/selectors.js